import ReactDOMClient from 'react-dom/client';
import { configure } from 'mobx';
import { initAjaxHandlersCommon } from '@servicetitan/ajax-handlers';

import { App } from './app';

configure({ enforceActions: 'observed' });
initAjaxHandlersCommon();

ReactDOMClient.createRoot(document.getElementById('app')!).render(<App />);
